import Dashboard from "../Dashboard/Dashboard";
import {MemberListItems} from '../Dashboard/ListItems';

export default function MemberDashboard({Content, ...rest}) {

  return (
    <>
      <Dashboard Content={Content} ListItems={MemberListItems} {...rest} />
    </>
  );
}
